import React, { createContext } from 'react';
import PropTypes from 'prop-types';

/**
 * @typedef {Object} Fields
 * @property {Object} data
 * @property {boolean} isVehicleEV
 */

/**
 * @typedef {Object} JSSComponentContext
 * @property {string} componentName
 * @property {Fields} fields
 * @property {function} SubAppTitleComponent
 * @property {function} DealerCardComponent
 * @property {function} DisclaimerComponent
 */

/** @type {JSSComponentContext} */
const initialContext = {};

export const JSSComponentContext = createContext(initialContext);

export const JSSComponentProvider = ({ children, ...props }) => (
  <JSSComponentContext.Provider value={props}>{children}</JSSComponentContext.Provider>
);

JSSComponentProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
